import { DbConnectedSensorBoolean } from "../../Devices/DbConnectedSensorBoolean"
import { DbConnectedSensorNumber } from "../../Devices/DbConnectedSensorNumber"
import { WsPotlijnNotificationItem } from "./WsPotlijnNotificationItem"

export class WsPotlijnNotificationItems{
  ListItems!: WsPotlijnNotificationItem[]
}

export class Settings{
  moduleId!: string
  enableNotifications!: boolean
  enableSound!: boolean

  connectedSensorsBoolean!: [DbConnectedSensorBoolean]
  connectedSensorsNumber!: [DbConnectedSensorNumber]
}